export default __webpack_public_path__ + "static/lehr-equation-light-899eb3ef0ee1ebe705a4e86a764e2b98.png";